module.exports = __webpack_public_path__ + "static/6-actual-git-9eedae92aa44a7badbdb3b2ac0d60b64.svg";